import {
  HttpClient,
  HttpContext,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, firstValueFrom, timeout } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { CUSTOM_BASE_URL } from '../../interceptors/token.interceptor';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SocketHttpRequestService {
  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {}

  async detectSSLSupport(): Promise<{
    useSSL: boolean;
    baseUrl: string;
    wsUrl: string;
  }> {
    try {
      const baseUrl = this.configService.getBaseUrl();
      await firstValueFrom(
        this.http
          .get('', {
            context: new HttpContext().set(
              CUSTOM_BASE_URL,
              environment.chatBaseUrl
            ),
          })
          .pipe(timeout(5000), catchError(this.handleError))
      );

      return {
        useSSL: baseUrl.startsWith('https'),
        baseUrl: baseUrl,
        wsUrl: this.configService.getWsUrl(),
      };
    } catch (error) {
      throw new Error('Failed to connect to server');
    }
  }

  private handleError = (error: HttpErrorResponse): Observable<any> => {
    console.error('HTTP Error:', error);
    throw error;
  };
}
